import React, { useState } from "react"

export const Contact = () => {
  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [message, setMessage] = useState("")
  const [isSubmitted, setIsSubmitted] = useState(false)

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    // In a real application, you would send this data to a server
    console.log("Form submitted:", { name, email, message })
    setIsSubmitted(true)
    // Reset form fields
    setName("")
    setEmail("")
    setMessage("")
  }

  return (
    <section className="bg-gray-50 py-24">
      <div className="container mx-auto px-6 pt-16">
        <h2 className="text-4xl font-semibold text-gray-800 text-center mb-12 animate-fade-in">
          Contact Us
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          {/* Contact Form */}
          <div className="bg-white rounded-2xl p-8 shadow-md animate-slide-in-left">
            {isSubmitted ? (
              <div className="text-center animate-fade-in">
                <p className="text-green-600 text-xl mb-4">
                  Thank you for your message! We'll get back to you soon.
                </p>
                <button
                  onClick={() => setIsSubmitted(false)}
                  className="bg-green-500 text-white py-2 px-4 rounded-full hover:bg-green-600 transition-colors duration-200"
                >
                  Send Another Message
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                <div className="mb-4">
                  <label
                    htmlFor="name"
                    className="block text-gray-700 text-sm font-bold mb-2"
                  >
                    Name
                  </label>
                  <input
                    type="text"
                    id="name"
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    placeholder="Your Name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </div>
                <div className="mb-4">
                  <label
                    htmlFor="email"
                    className="block text-gray-700 text-sm font-bold mb-2"
                  >
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    placeholder="Your Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                <div className="mb-6">
                  <label
                    htmlFor="message"
                    className="block text-gray-700 text-sm font-bold mb-2"
                  >
                    Message
                  </label>
                  <textarea
                    id="message"
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    placeholder="Your Message"
                    rows={21}
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    required
                  ></textarea>
                </div>
                <div className="flex items-center justify-between">
                  <button
                    className="inline-block bg-green-800 text-white py-3 px-8 rounded-full hover:bg-green-600 font-semibold
                    transition
                    duration-300
                    ease-in-out
                    hover:-translate-y-1
                    hover:scale-110
                    "
                    type="submit"
                  >
                    Send Message
                  </button>
                </div>
              </form>
            )}
          </div>

          {/* Contact Details and Map */}
          <div className="bg-white rounded-2xl shadow-md overflow-hidden animate-slide-in-right">
            <div className="p-8">
              <h3 className="text-2xl font-semibold text-gray-800 mb-6">
                Our Location
              </h3>
              <div className="mb-6">
                <p className="text-gray-700 mb-2">
                  <span className="font-semibold">Address:</span> 123 Modular
                  Street, San Francisco, CA 94107
                </p>
                <p className="text-gray-700 mb-2">
                  <span className="font-semibold">Phone:</span> (123) 456-7890
                </p>
                <p className="text-gray-700 mb-2">
                  <span className="font-semibold">Email:</span>{" "}
                  info@modularhomes.com
                </p>
              </div>
              <div className="bg-gray-100 p-6 rounded-lg">
                <h4 className="text-xl font-semibold text-gray-800 mb-4">
                  Business Hours
                </h4>
                <ul className="text-gray-700">
                  <li>Monday - Friday: 9:00 AM - 6:00 PM</li>
                  <li>Saturday: 10:00 AM - 4:00 PM</li>
                  <li>Sunday: Closed</li>
                </ul>
              </div>
            </div>
            <div className="h-96">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3155.649449578939!2d-122.419416!3d37.774929!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808580819d1ba1a5%3A0x499efbbca0963a16!2sSan%20Francisco%2C%20CA!5e0!3m2!1sen!2sus!4v1679898989898"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen={true}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Our Location"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
